export default __webpack_public_path__ + "static/media/deep-draw-pressed-components.8e9a92f1.webp";